<template>
  <div class='popular'>
    <div class="box">
      <div class="title">
          为什么六西格玛推行不下去？因为没能跨过七大障碍
        </div>
        <div class="author">
          作者：Jay from 捷思企业管理顾问(深圳)有限公司
        </div>
        <div class="headImg">
          <img :src="headImgUrl" alt="">
        </div>
        <div class="note">
          <div class="text">
            <div class="fontBold">推行六西格玛的七大障碍</div>
          </div>
          <div class="text">
            <span>作为二十世纪最伟大CEＯ之一的前通用电气执行长杰克.威尔奇，其除了在通用电气所创造的丰功伟业外，另一个令世人为之惊艳的便是在全球造就了一场追逐”六西格玛管理”的浪潮。这股浪潮约在2000年初兴起，作为世界工厂的中国，身处时代的洪流，自然也不落于人后，一场六西格玛推行运动如火如荼地展开。</span>
          </div>
          <div class="text">
            <span>但凡六西格玛或其他变革活动，皆强调高层的支持、投入和领导力的发挥是变革活动成功的关键。质量管理大师戴明有句名言:「质量始于董事会」，他很清楚地告诉人们，领导者的责任，同时也提到，要落实质量，</span>
            <span class="fontBold">需将各项努力放在具有战略的位置，而不是流于各种技术工具。</span>
          </div>
          <div class="text">
            <span>高层支持是活动成功的关键，这道理既是至理名言，亦是老生常谈，这个观点大家都很容易理解。但即便是在有高层支持的条件下，该如何针对六西格玛(或其他变革活动)做战略性的部署和展开，却往往是被忽视并成为最终活动失败的根本原因。笔者根据多年的六西格玛推行和辅导的经验，将不当的六西格玛战略部署所衍生的不良反应，归纳总结为</span>
            <span class="fontBold">「七大障碍」：</span>
          </div>
          <div class="text">
            <div>
              <span class="fontBold">一、洛阳纸贵：</span>
              <span>追求时尚，投入庞大的导入成本和时程周期，却未见成效。</span>
            </div>
            <div>
              <span class="fontBold">二、居大不易：</span>
              <span>部署专业推行团队、聘请咨询顾问公司培训和辅导、引入昂贵的专业统计软件。</span>
            </div>
            <div>
              <span class="fontBold">三、兴师动众：</span>
              <span>过度期待人人都是黑带、绿带高手。</span>
            </div>
            <div>
              <span class="fontBold">四、虚与尾蛇：</span>
              <span>过度重视改善报告的书面呈现，走过场，耗费员工大量时间做报告交差。</span>
            </div>
            <div>
              <span class="fontBold">五、浮光掠影：</span>
              <span>学习统计学的门槛高，易打击学习意愿，培训完后通通忘记。</span>
            </div>
            <div>
              <span class="fontBold">六、事过境迁：</span>
              <span>培训之后未持续改进活动，忘却刚习得的六西格玛技术和参与热诚。</span>
            </div>
            <div>
              <span class="fontBold">七、退避三舍：</span>
              <span>欠缺体制来建构持续改进和学习的文化，参与此类活动被视为是额外的负担。</span>
            </div>
          </div>
          <div class="text">
            <div>详述如下，</div>
            <div>一、洛阳纸贵：</div>
            <div>一昧追求流行，未深入思考自身的条件和特质，拟定符合企业发展方向和使命的战略。大张旗鼓全面展开的推行方式，例如：50%、80％的员工要完成120小时、80小时的培训课程并取得黑带、绿带资格，每人每年需完成几个项目并达成目标效益等等的推行政策，轰轰动动地展开培训和项目发表，结果往往在投入大量经费和员工的时间成本后，未给企业的DNA带来些微的改变，流行退去之后回归原本的状态。</div>
            <div>二、居大不易：</div>
            <div>基础建设的投入，包括部署专业推行团队、聘请咨询顾问公司培训和辅导、引入专业统计软件等等，成本所费不赀，然并非所有企业都具备像通用电气等大型企业那样的资源和人才素质，变革不等于花大钱，花大钱亦不保证有效，但真正该投资的关键输入得舍得花，避免过犹不及。</div>
            <div>三、兴师动众：</div>
            <div>过度期待人人都是黑带、绿带高手，一个有作战力的部队不代表每个士兵都要是特种兵，适才适任才能发挥团队综效。黑带是六西格玛管理中最重要的角色，绿带则是执行项目的基层力量，黑带和绿带的选、用、育、留，皆需谨慎谋划。然而，一般企业很难做到书本上建议的规格，像是专职的黑带、轮调机制、黑带/绿带覆盖率等等。企业应思考并确认想透过导入六西格玛来达到什么样的战略意图，并审视自身的环境和条件，拟定合理的战略部署，切勿盲目跟风。</div>
            <div>四、虚与尾蛇：</div>
            <div>变革和改进活动的本质若不是持续改进、追求卓越这类的价值观，其结果就会变成作秀或变成差事，过度重视改善报告的书面呈现，走过场，耗费员工大量时间做报告交差。这往往是企业文化不健康所致，始作俑者当然是领导高层。</div>
            <div>五、浮光掠影：</div>
            <div>笔者本身虽具数理统计背景，但坚信”一位优秀的黑带，不代表他/她的统计学要很厉害”，六西格玛是集成的系统化改进技术，统计学是其重要的组成要素，但不是全部。过度强调统计学的培训将造成学习门槛过高，易打击学习意愿，培训完后通通忘记。</div>
            <div>六、事过境迁：</div>
            <div>无论是六西格玛或是其他变革活动，都是一场永无止境的学习成长之旅，甚至可以说透过六西格玛来引领员工达成高层的战略意图，型塑企业文化，建立正确的价值观和信仰。若培训之后未能持续改进活动，很快地将忘却刚习得的六西格玛知识和参与热诚，没有持续做中学、学中做，则终归只是一场绚烂的烟火秀。</div>
            <div>七、退避三舍：</div>
            <div>欠缺合适的体制来建构持续改进和学习的文化，参与此类活动被视为是额外的负担。学习风气鼎盛的企业较无此问题，而对于士气低迷、组织僵化、官僚化的企业，提振士气和改变主管们的思维更重于推行六西格玛，如前所述，六西格玛可作为实现高层战略意图的工具，换言之，在推行六西格玛之上，还有经营管理面的战略规划这样的更高层级思维，以及人性面的以人为本、人尽其才等的指导思想，这就得需要高层领导力的发挥。</div>
          </div>
          <div class="text">
            <div>六西格玛历经30多年的应用和发展，其体系益发完善，实是企业进行变革的一项利器，更是在进入智能制造/服务时代前，所不得不先用于强健企业文化体质的一帖处方良药。惟六西格玛起源于欧美，若仅一昧的模仿复制，不但无法习得其精髓，最后变革活动往往无疾而终，因此导入前需深刻体会其背后的意涵，并结合企业的发展方针，拟定符合自身环境和条件的战略。之后会陆续针对上述之七大障碍讨论应对之策，以上经验之谈希冀能给相关领域的读者提供参考价值，避免在六西格玛及其他的变革或持续改进活动上劳而无功。</div>
          </div>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  name: '',
  components: {
  },
  data () {
    return {
      headImgUrl: require('../../assets/img/article4.png')
    }
  },
  methods: {
  }
}
</script>
<style scoped>
.popular{
  text-align: center;
  text-justify: newspaper;
  text-align: justify;
  margin-bottom: 4rem;
  font-size: 24px;
  line-height: 48px;
}
.popular .box{
  width: 90%;
}
.popular .box{
  margin: 0 auto;
}
.popular .box .title{
  font-weight: bold;
  font-size: 34px;
  margin: 16px 0px;
}
.popular .box .author{
  margin: 16px 0px;
  font-size: 16px;
}
.popular .box .note{
  text-indent: 2em;
}
.popular .box .note .text{
  margin-top: 40px;
}
@media screen and (max-width: 1200px){
}
@media screen and (max-width: 992px){
  .popular{
    font-size: 20px;
  }
  .popular .box .title{
    font-size: 30px;
  }
}
@media screen and (max-width: 767px){
}
@media screen and (max-width: 450px){
  .popular .box .author{
    font-size: 12px;
  }
  .popular{
    font-size: 16px;
    line-height: 32px;
  }
    .popular .box .title{
    font-size: 24px;
  }
  .popular .box .note .text{
    margin-top: 20px;
  }
}
</style>
